import AuthService from './AuthService';
import ApiService from "./ApiService";

class AttributesService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._tableDataUrl = '/attributes/table-data';
        this._categoriesUrl = '/attributes/categories';
        this._attributesUrl = '/attributes/enum-attributes';
        this._createAttributeUrl = '/attributes/enum-attributes/create';
        this._updateAttributeUrl = '/attributes/enum-attributes/update';
        this._deleteAttributeUrl = '/attributes/enum-attributes/delete';
        this._attributesValuesUrl = '/attributes/enum-attributes-values';
        this._attributesValuesInitialUrl = '/attributes/enum-attributes-values/initial';
        this._createAttributeValueUrl = '/attributes/enum-attributes-values/create';
        this._updateAttributeValueUrl = '/attributes/enum-attributes-values/update';
        this._deleteAttributeValueUrl = '/attributes/enum-attributes-values/delete';
    }


    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    create(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._createProductUrl, data, headers);
    }

    getTableData() {
        return this.postResource(this._tableDataUrl, {}, this.getBaseHeaders());
    }

    getAttributes() {
        return this.postResource(this._attributesUrl, {}, this.getBaseHeaders());
    }

    createAttribute(params) {
        return this.postResource(this._createAttributeUrl, params, this.getBaseHeaders());
    }

    updateAttribute(params) {
        return this.postResource(this._updateAttributeUrl, params, this.getBaseHeaders());
    }

    deleteAttribute(id) {
        return this.postResource(this._deleteAttributeUrl, {id: id}, this.getBaseHeaders());
    }

    getAttributesValues(params) {
        return this.postResource(this._attributesValuesUrl, params, this.getBaseHeaders());
    }

    getAttributeValue(id) {
        return this.postResource(this._attributesValuesInitialUrl, {id: id}, this.getBaseHeaders());
    }

    createAttributeValue(params) {
        return this.postResource(this._createAttributeValueUrl, params, this.getBaseHeaders());
    }

    updateAttributeValue(params) {
        return this.postResource(this._updateAttributeValueUrl, params, this.getBaseHeaders());
    }

    deleteAttributeValue(id) {
        return this.postResource(this._deleteAttributeValueUrl, {id: id}, this.getBaseHeaders());
    }
}

const service = new AttributesService(AuthService);

export default service;
